import React, { useEffect } from 'react';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Grid from '@mui/material/Unstable_Grid2';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import axios from "axios";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

export default function DialogoEditar(props) {
  const [nombre, setNombre] = React.useState('');
  const [nombreError, setNombreError] = React.useState('');
  const [app, setApp] = React.useState('');
  const [appError, setAppError] = React.useState('');
  const [apm, setApm] = React.useState('');
  const [apmError, setApmError] = React.useState('');
  const [usuario, setUsuario] = React.useState('');
  const [usuarioError, setUsuarioError] = React.useState('');
  const [costo, setCosto] = React.useState('');
  const [costoError, setCostoError] = React.useState('');
  const [costoLibre, setCostoLibre] = React.useState('');
  const [costoLibreError, setCostoLibreError] = React.useState('');
  const [estado, setEstado] = React.useState(1);

  const handleClose = () => {
    props.setOpen(false)
  };  

  useEffect(() => {    
    setNombre(props.arrayDatos.nombres);
    setApp(props.arrayDatos.aPaterno);
    setApm(props.arrayDatos.aMaterno);
    setUsuario(props.arrayDatos.usuario);
    setCosto(props.arrayDatos.costo);
    setCostoLibre(props.arrayDatos.costoLibre);
    setEstado(props.arrayDatos.estado); 
  }, []);

  function guardar(){        
    props.setDialogNotificacionOpen(true);
    props.setDialogNotificacionTipo('Carga');
    props.setDialogNotificacionMensaje('');

    var ban = 0;

    if (nombre === "") { setNombreError('error'); ban = 1; } else { setNombreError(''); }
    if (app === "") { setAppError('error'); ban = 1; } else { setAppError(''); }
    if (apm === "") { setApmError('error'); ban = 1; } else { setApmError(''); }
    if (usuario === "") { setUsuarioError('error'); ban = 1; } else { setUsuarioError(''); }
    if (costo === "") { setCostoError('error'); ban = 1; } else { setCostoError(''); }
    if (costoLibre === "") { setCostoLibreError('error'); ban = 1; } else { setCostoLibreError(''); }

    if(ban === 0){
      let resultado = parseFloat(costo);  
      // console.log(resultado + ' VS ' + horas) 

      if(!Number.isNaN(resultado)){
        // console.log('numero')
        let a = resultado - costo;
        // console.log(a)
        if(a !== 0){
          // console.log('diferentes')
          setCostoError('error');
          ban = 2;
        }
      } else {
        // NO ES NUMERO
        // console.log('no es numero')
        setCostoError('error');
        ban = 2;
      }

      if(Number.isNaN(resultado) && resultado !== costo){   
        console.log(!Number.isNaN(resultado));
      }
    }

    if(ban === 0){
      let resultado = parseFloat(costoLibre);  
      // console.log(resultado + ' VS ' + horas) 

      if(!Number.isNaN(resultado)){
        // console.log('numero')
        let a = resultado - costoLibre;
        // console.log(a)
        if(a !== 0){
          // console.log('diferentes')
          setCostoLibreError('error');
          ban = 2;
        }
      } else {
        // NO ES NUMERO
        // console.log('no es numero')
        setCostoLibreError('error');
        ban = 2;
      }

      if(Number.isNaN(resultado) && resultado !== costoLibre){   
        console.log(!Number.isNaN(resultado));
      }
    }

    if(ban === 0){
      axios.post(props.ruta + "backend/usuarios/editar.php", {
          userId: props.userArray.id,
          id: props.arrayDatos.id,
          nombre: nombre,
          app: app,
          apm: apm,
          usuario: usuario,
          estado: estado,
          costo: costo,
          costoLibre: costoLibre,
      })
      .then(result => {
          var data = result.data;

          if (data[0].error === 0) {
            props.setDialogNotificacionOpen(false);
            props.getDatos();
            props.setOpen(false);
          } else {
            props.setDialogNotificacionTipo('Error');
            props.setDialogNotificacionMensaje("Se ha producido un error al momento de guardar, tome una captura de pantalla y contacte al administrador");
          }

      });      
    } else if(ban === 1){
      props.setDialogNotificacionTipo('Alerta');
      props.setDialogNotificacionMensaje('No se aceptan campos vacios');
    } else if(ban === 2){
      props.setDialogNotificacionTipo('Alerta');
      props.setDialogNotificacionMensaje('Solo se aceptan números en los campos de "Costo patronal" y "Costo libre"');
    } 
  }

  return (
    <React.Fragment>
      <BootstrapDialog
        aria-labelledby="customized-dialog-title"
        open={props.open}
        maxWidth='md'
        fullWidth={true}
      >        
        <DialogTitle id="alert-dialog-title" style={{backgroundColor: '#082342', color: '#ffffff', textAlign: 'center'}}>
          <Typography variant="h5" style={{textAlign: 'center'}}>
            Editar
          </Typography> 
        </DialogTitle>
        <DialogContent dividers>
          <Grid container spacing={2} justifyContent={'center'}>
            <Grid item xs={12} md={4}>
              <TextField id="nombre" label="Nombre" variant="outlined" style={{width:'100%'}}               
                value={nombre}
                onChange={(event) => setNombre(event.target.value)}
                error={nombreError}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <TextField id="app" label="A. Paterno" variant="outlined" style={{width:'100%'}}               
                value={app}
                onChange={(event) => setApp(event.target.value)}
                error={appError}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <TextField id="apm" label="A. Materno" variant="outlined" style={{width:'100%'}}               
                value={apm}
                onChange={(event) => setApm(event.target.value)}
                error={apmError}
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <TextField id="usuario" label="Usuario" variant="outlined" style={{width:'100%'}}               
                value={usuario}
                onChange={(event) => setUsuario(event.target.value)}
                error={usuarioError}
              />
            </Grid>

            <Grid item xs={12} md={3}>
              <TextField id="costo" label="Costo patronal" variant="outlined" style={{width:'100%'}}               
                value={costo}
                onChange={(event) => setCosto(event.target.value)}
                error={costoError}
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <TextField id="costoLibre" label="Costo libre" variant="outlined" style={{width:'100%'}}               
                value={costoLibre}
                onChange={(event) => setCostoLibre(event.target.value)}
                error={costoLibreError}
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <TextField
                id="outlined-select-currency"
                select
                label="Estado"
                value={estado}
                style={{width: '100%'}}
                onChange={(event) => setEstado(event.target.value)}
              >
                <MenuItem key={0} value={0}>
                  Baja
                </MenuItem>
                <MenuItem key={1} value={1}>
                  Activo
                </MenuItem>
              </TextField>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} variant="contained" style={{backgroundColor: '#a31545', color: '#ffffff'}}>
            Cancelar
          </Button>
          <Button onClick={guardar} variant="contained" style={{backgroundColor: '#082342', color: '#ffffff'}}>
            Aceptar
          </Button>
        </DialogActions>
      </BootstrapDialog>
    </React.Fragment>
  );
}